
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-integrations",
      function () {
        return require("private-next-pages/ai-integrations.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-integrations"])
      });
    }
  